import React, { FC } from 'react';
import imageSources from '../../../../../../constants/imageSources/imageSources';
import * as Styled from './styles';

const ImportDropZoneBackground: FC = () => (
    <Styled.ItemDiv>
        <Styled.ImportDropZoneBackgroundWhiskers src={imageSources.DROP_ZONE.IMPORT.WHISKERS} alt="loader" />
        <Styled.ImportDropZoneBackgroundText>
            Select or drag a thumbnail to display news highlights from your Staffbase app.
        </Styled.ImportDropZoneBackgroundText>
        <Styled.ImportDropZoneBackgroundArrow src={imageSources.DROP_ZONE.IMPORT.ARROW} alt="loader" />
    </Styled.ItemDiv>
);

export default ImportDropZoneBackground;
